export default __webpack_public_path__ + "static/media/A5.689011e8.mp3";